import { Component, ElementRef, Input } from "@angular/core";
import { SvgIconComponent } from "../svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "error-popup",
    imports: [SvgIconComponent],
    templateUrl: "./error-popup.component.html"
})
export class ErrorPopUpComponent {
    @Input({ required: true }) public message!: string;
    @Input() public durationSec: number = 3;

    public readonly svgIcon = SvgIcon.Close;

    public constructor(private element: ElementRef) {

    }

    public ngOnInit(): void {
        setTimeout(() => this.onClose(), this.durationSec * 1000);
    }

    public onClose(): void {
        this.element.nativeElement.remove();
    }
}